<template>
  <v-snackbar v-model="visible" color="blue darken-2" :timeout="5000" top>
    {{ $t('limit') }},

    <span
        v-if="$account.current.rules['check-position'].max_check_per_day === 20"
        class="white--text"
        style="text-decoration: underline; cursor: pointer;" @click="subscribe()">
      {{ $t('subscribe') }}
    </span>
    <span v-else>
      {{ $t('wait') }}
    </span>

    <template v-slot:action="{ attrs }">
      <v-btn v-if="$vuetify.breakpoint.smAndUp && $account.current.rules['check-position'].max_check_per_day === 20" @click="subscribe()" light elevation="0" class="primary--text mr-2" v-bind="attrs">
        {{ $t('actions.subscribe') }}
      </v-btn>
      <v-btn text v-bind="attrs" @click="visible = false">
        {{ $t('actions.close') }}
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
  export default {
    name: 'PaymentRequiredForMoreChecksNotification',
    data () {
      return {
        visible: false
      }
    },
    methods: {
      subscribe() {
        this.visible = false
        this.$router.push('account/subscriptions')
      }
    },
    mounted () {
      this.$bus.on('notification/payment_required_for_more_checks', () => {
        this.visible = true
      })
    }
  }
</script>

<i18n>
{
	"en": {
		"limit": "You have reached the maximum number of verifications for today",
		"subscribe": "subscribe to an offer to increase this limit!",
		"wait": "you can make new ones tomorrow."
	},
	"es": {
		"limit": "Ha alcanzado el número máximo de verificaciones para hoy",
		"subscribe": "suscríbase a una oferta para aumentar este límite!",
		"wait": "puedes hacer otros nuevos mañana."
	},
	"fr": {
		"limit": "Vous avez atteint le nombre maximum de vérifications pour aujourd'hui",
		"subscribe": "souscrivez à une offre pour augmenter cette limite !",
		"wait": "vous pourrez en effectuer de nouvelles demain."
	},
	"it": {
		"limit": "Hai raggiunto il numero massimo di verifiche per oggi",
		"subscribe": "abbonati a un'offerta per aumentare questo limite!",
		"wait": "potrai effettuarne di nuove domani."
	},
	"pt": {
		"limit": "Atingiu o número máximo de verificações para hoje",
		"subscribe": "subscreva uma oferta para aumentar este limite!",
		"wait": "poderá efetuar novas amanhã."
	},
	"pl": {
		"limit": "Osiągnąłeś maksymalną liczbę weryfikacji na dziś",
		"subscribe": "subskrybuj ofertę, aby zwiększyć ten limit!",
		"wait": "możesz dokonać nowych jutro."
	}
}
</i18n>
